import { CheckboxDesignTokens } from '@primeng/themes/types/checkbox';

interface ICustomCheckboxDesignTokens extends CheckboxDesignTokens {
  root: CheckboxDesignTokens['root'] & {
    hoverRing?: {
      width?: string;
      offset?: string;
      color?: string;
    };
  };
  icon: CheckboxDesignTokens['icon'] & {
    lg: {
      size: string;
    };
  };
}

export const baseCheckboxToken: ICustomCheckboxDesignTokens = {
  // disabled is not defined yet
  root: {
    // borderRadius: '{border.radius.sm}',
    width: '1rem',
    height: '1rem',
    // background: '{form.field.background}',
    // checkedBackground: '{primary.color}',
    checkedHoverBackground: '{primary.color}',
    // disabledBackground: '{form.field.disabled.background}',
    // filledBackground: '{form.field.filled.background}',
    borderColor: '{gray.100}',
    hoverBorderColor: '{gray.100} ',
    // focusBorderColor: '{form.field.border.color}',
    // checkedBorderColor: '{primary.color}',
    checkedHoverBorderColor: '{primary.color}',
    // checkedFocusBorderColor: '{primary.color}',
    // checkedDisabledBorderColor: '{form.field.border.color}',
    // invalidBorderColor: '{form.field.invalid.border.color}',
    shadow: 'none',
    disabledBackground: 'transparent',
    checkedDisabledBorderColor: '{gray.200}',
    // focusRing: {
    //   width: '{focus.ring.width}',
    //   style: '{focus.ring.style}',
    //   color: '{focus.ring.color}',
    //   offset: '{focus.ring.offset}',
    //   shadow: '{focus.ring.shadow}',
    // },
    // transitionDuration: '{form.field.transition.duration}',
    // sm: {
    //   width: '1rem',
    //   height: '1rem',
    // },
    // lg: {
    //   width: '1.5rem',
    //   height: '1.5rem',
    // },
    hoverRing: {
      color: '{primary.100}',
      offset: '2px',
      width: '1px',
    },
  },
  icon: {
    size: '0.5rem',
    // color: '{form.field.color}',
    // checkedColor: '{primary.contrast.color}',
    // checkedHoverColor: '{primary.contrast.color}',
    // disabledColor: '{form.field.disabled.color}',
    // sm: {
    //   size: '0.75rem',
    // },
    lg: {
      size: '1.25rem',
    },
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    .p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {
      outline: ${dt('checkbox.hoverRing.width')} solid ${dt('checkbox.hoverRing.color')};
      outline-offset: ${dt('checkbox.hoverRing.offset')};
    }

    p-checkbox.transparent-checkbox .p-checkbox:not(.p-disabled):not(.p-checkbox-checked) .p-checkbox-box {
      background: transparent !important;
    }
     `,
};
